var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCopyLink(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon-size",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8027_19892)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "icon-svg",
    d: "M3.99994 6.48999L0.789939 9.66999C0.696211 9.76295 0.621816 9.87355 0.571048 9.99541C0.520279 10.1173 0.494141 10.248 0.494141 10.38C0.494141 10.512 0.520279 10.6427 0.571048 10.7646C0.621816 10.8864 0.696211 10.997 0.789939 11.09L2.90994 13.21C3.0029 13.3037 3.1135 13.3781 3.23536 13.4289C3.35722 13.4797 3.48793 13.5058 3.61994 13.5058C3.75195 13.5058 3.88266 13.4797 4.00452 13.4289C4.12637 13.3781 4.23698 13.3037 4.32994 13.21L7.50994 9.99999",
    stroke: "#323A46",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    className: "icon-svg",
    d: "M10.0002 7.50994L13.1802 4.32994C13.274 4.23698 13.3484 4.12637 13.3991 4.00452C13.4499 3.88266 13.476 3.75195 13.476 3.61994C13.476 3.48793 13.4499 3.35722 13.3991 3.23536C13.3484 3.1135 13.274 3.0029 13.1802 2.90994L11.0902 0.789939C10.9973 0.696211 10.8867 0.621816 10.7648 0.571048C10.643 0.520279 10.5122 0.494141 10.3802 0.494141C10.2482 0.494141 10.1175 0.520279 9.99566 0.571048C9.8738 0.621816 9.7632 0.696211 9.67023 0.789939L6.49023 3.99994",
    stroke: "#323A46",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    className: "icon-svg",
    d: "M9 5L5 9",
    stroke: "#323A46",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8027_19892"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyLink);
export default __webpack_public_path__ + "static/media/copy_link.15a2dd7b94ec4e1d2cbeb22b191a7e5e.svg";
export { ForwardRef as ReactComponent };